import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { KitInput, KitInputProps } from "./Input";

export const KitPasswordInput = forwardRef<
  HTMLInputElement,
  Omit<KitInputProps, "type" | "iconRight" | "onIconRightClick">
>(({ placeholder, ...props }, ref) => {
  const [visible, setVisible] = useState(false);
  return (
    <KitInput
      ref={ref}
      {...props}
      type={visible ? "text" : "password"}
      placeholder={placeholder ?? "Password"}
      iconRight={visible ? EyeOff : Eye}
      onIconRightClick={() => setVisible((v) => !v)}
    />
  );
});

KitPasswordInput.displayName = "KitPasswordInput";
